import React from "react";
import { FaFacebookF, FaLinkedin, FaTwitter, FaYoutube, FaSkype } from 'react-icons/fa';

const TeamMembersCard = ({ data }) => {
  return (
    <div className="">
      <div className="team-member">
        <div className="team-thumb">
          <img
            src={data.thumbnail || "/images/team-members/default.jpg"}
            alt={data.title || "Team Member"}
          />
          
        </div>
    
      </div>
    </div>
  );
};

export default TeamMembersCard;
